import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from '@angular/forms';
import { ItemModifierGroup } from '../../api/v1/models/item-modifier-group';
import { ModifierItem } from './modifier-item.interface';

@Component({
  selector: 'app-modifier-list',
  templateUrl: './modifier-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ModifierListComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ModifierListComponent),
      multi: true,
    }
  ]
})
export class ModifierListComponent implements ControlValueAccessor, Validator {
  constructor (
    private cdr: ChangeDetectorRef
  ) {}

  validate(control: FormControl<ModifierItem[] | null>): ValidationErrors | null {
    return this.formControl.valid ? null : this.formControl.errors
  }

  @Input() modifierGroup: ItemModifierGroup;

  @Input() isGroupModifier: boolean;
  @Input() minCount: number;
  @Input() maxCount: number;
  @Input() byDefault: number;

  @Output() changeModifiers = new EventEmitter();

  formControl = new FormControl<ModifierItem[] | null>(null);

  onChange = (items: ModifierItem[] | null) => {};
  onTouched: any = () => {};

  registerOnChange (fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched (fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState (isDisabled: boolean): void {
  }

  writeValue(obj: ModifierItem[]): void {
    this.formControl.setValue(obj)
  }

  onChangeModifiers(): void {
    this.onChange(this.formControl.getRawValue())
    this.changeModifiers.emit(this.formControl.getRawValue());

    this.cdr.detectChanges();
  }
}
